﻿
function canCancel(job) {
	return !job.completed
		&& (job.flsStatus === null || job.flsStatus.toUpperCase() === "RECORDED")
		&& job.state !== "Cancelled";
}

export const JobHelperFunctions = {
	canCancel: canCancel
};

